import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function Cursor() {
    const dotRef = useRef(null);

    useEffect(() => {
        if (!window.matchMedia("(pointer: fine)").matches) return;
        const dot = dotRef.current;
        document.documentElement.classList.add("cursor-on");
        gsap.set(dot, { x: -100, y: -100 });
        const xTo = gsap.quickTo(dot, "x", { duration: 0.25, ease: "power3" });
        const yTo = gsap.quickTo(dot, "y", { duration: 0.25, ease: "power3" });
        const move = (e) => {
            dot.classList.add("live");
            xTo(e.clientX);
            yTo(e.clientY);
        };
        const over = (e) => {
            const hit = e.target.closest(
                "a, button, input, textarea, [data-cursor]"
            );
            dot.classList.toggle("ring", !!hit);
        };
        window.addEventListener("mousemove", move);
        window.addEventListener("mouseover", over);
        return () => {
            window.removeEventListener("mousemove", move);
            window.removeEventListener("mouseover", over);
            document.documentElement.classList.remove("cursor-on");
        };
    }, []);

    return <div ref={dotRef} className="cursor-dot" aria-hidden="true" />;
}
